import { render, staticRenderFns } from "./AMLFormWizard.vue?vue&type=template&id=546e7038&scoped=true"
import script from "./AMLFormWizard.vue?vue&type=script&lang=js"
export * from "./AMLFormWizard.vue?vue&type=script&lang=js"
import style0 from "./AMLFormWizard.vue?vue&type=style&index=0&id=546e7038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e7038",
  null
  
)

export default component.exports